import { queryOptions } from "@tanstack/react-query";
import { getInformation, getInvitations, getMembers, getProfile } from "./api";

/** Who is signed in and in what standing: the _authenticated boundary resolves it once. */
export const currentResellerQuery = () =>
  queryOptions({ queryKey: ["reseller", "current"], queryFn: async () => (await getProfile()).data });

/** What the reseller sent staff before, to fill the form again; null until it sends. */
export const informationQuery = () =>
  queryOptions({ queryKey: ["reseller", "information"], queryFn: async () => (await getInformation()).data });

/** Who is in the team, owner first. */
export const membersQuery = () =>
  queryOptions({ queryKey: ["reseller", "members"], queryFn: async () => (await getMembers()).data });

/** The team's open invitations, newest first; inviting someone invalidates it. */
export const invitationsQuery = () =>
  queryOptions({ queryKey: ["reseller", "invitations"], queryFn: async () => (await getInvitations()).data });
